export const Message = ({ className, text }) => {
  return <p className={className}>{text}</p>;
};
